import { multiMap } from '../map/map-multi.js';
import { singleMap } from '../map/map-single.js';

export default {
  init() {
    multiMap();

    $('#zipSearch').submit( function (e) {
      e.preventDefault();
      var search = $('#zipSearch input').val();

      $('#locations_list ul li' ).each( function(){
        // let blog_id = $(this).attr('data-id');
        let zips = jQuery(this).attr('data-serviceAreas');
        let zipsArr = (zips) ? zips.split(',').filter(e => e.trim().length).join('') : [];

        if( zipsArr.includes(search) ) {

          $('.hide_if_has_result').hide();

          var sfl_container = $('#sfl_map');
          sfl_container.attr('data-lat', $(this).attr('data-lat'));
          sfl_container.attr( 'data-lng', $(this).attr('data-lng'));
          sfl_container.attr('data-title', $(this).attr('data-title'));
          sfl_container.attr('data-address', $(this).attr('data-address'));
          sfl_container.attr('data-phone', $(this).attr('data-phone'));

          $('#searchMessage')
            .empty()
            .show()
            .attr('class', '')
            .addClass('alert')
            .addClass('alert-default')
            .html('<h4>Yes! Your area is covered.</h4> Fill out the form below for a fast & free estimate.');

            singleMap(true);

          $('#gravity_form_result').show();
            /*
            $.ajax({
               type : 'post',
               url : sfl_container.attr('data-ajax'),
               data : {
                action: 'gfLocationForm',
                blog_id: blog_id,
              },
               success: function(response) {
                $('#gravity_form_result').empty().append(response);
               },
            });
            */
          return false;
        } else {
          $('#searchMessage')
            .empty()
            .show()
            .attr('class', '')
            .addClass('alert')
            .addClass('alert-warning')
            .html('<h4>Sorry! Your zip code <em>' + search + '</em> is currently not covered.</h4>');
        }
      });
    });


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/locations.js